module.exports = __webpack_public_path__ + "img/logo-text.c612da25.png";